export const CHIP_MIN_WIDTH = 115;
export const overflowingTitleSx = {
  minWidth: 0,
  mr: 1,
  overflowWrap: "anywhere",
  whiteSpace: "normal",
};
export const nonOverflowingTitleSx = {
  whiteSpace: "normal",       
  overflowWrap: "break-word", 
  hyphens: "auto",            
  maxWidth: "100%",          
};
// Grey, uppercase table header row. Solid background so a sticky header covers scrolled rows
export const tableHeadRowSx = {
  "& th": {
    bgcolor: (theme) =>
      theme.palette.mode === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    fontWeight: 700,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "text.secondary",
    borderBottom: "2px solid",
    borderBottomColor: "divider",
  },
};
